import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  const register = useCallback(async (payload, clinic = false) => {
    const { data } = await api.post(clinic ? "/auth/register-clinic" : "/auth/register", payload);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout");
    setUser(false);
  }, []);

  const loginAs = useCallback(async (clinicId) => {
    const { data } = await api.post(`/super/impersonate/${clinicId}`);
    window.location.assign("/admin");
    return data;
  }, []);

  const stopImpersonation = useCallback(async () => {
    const { data } = await api.post("/auth/stop-impersonation");
    window.location.assign("/super");
    return data;
  }, []);

  return <AuthContext.Provider value={{ user, login, register, logout, loginAs, stopImpersonation }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export const homeFor = (u) => (u?.role === "super_admin" ? "/super" : u?.role === "clinic_owner" ? "/admin" : "/account");
